import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _class, _descriptor;
import { BaseMachine } from "abreact/incubator/ui/machine/BaseMachine";
import * as AbWebResources from "abweb/generated/locale/AbWebResources";
import { ClassUtils } from "abweb/utils/ClassUtils";
import { computed, observable, makeObservable } from "mobx";
export let ClientErrorRendererMachine = (_class = class ClientErrorRendererMachine extends BaseMachine {
  constructor(error) {
    super();
    _initializerDefineProperty(this, "_error", _descriptor, this);
    makeObservable(this);
    this._error = error;
  }
  get title() {
    if (this._error.titleDescription) {
      return this._error.titleDescription;
    }
    return AbWebResources.fallbackErrorTitle();
  }
  get message() {
    if (this._error.errorContext) {
      return this._error.errorContext;
    }
    return AbWebResources.fallbackErrorMessage();
  }
  get stackTrace() {
    if (this._error.underlyingError && ClassUtils.isInstanceOf(this._error.underlyingError, Error) && this._error.underlyingError.stack) {
      return this._error.underlyingError.stack;
    }
    return null;
  }
  get causedBy() {
    if (this._error.underlyingError && ClassUtils.isInstanceOf(this._error.underlyingError, Error)) {
      return this._error.underlyingError;
    }
    return null;
  }
  get showCausedBy() {
    return true;
  }
  getSupportDetailsText() {
    return null;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "_error", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "title", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "title"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "message", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "message"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "stackTrace", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "stackTrace"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "causedBy", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "causedBy"), _class.prototype), _class);
//# sourceMappingURL=ClientErrorRendererMachine.js.map
